import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import React, { useEffect } from "react";
import Breadcrumb from "../Component/Breadcrumb";

function MessageInner() {
  const { category } = useParams();

  // ✅ Convert "vice-principal" -> "Vice Principal"
  const formattedCategory = category
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  // ✅ Fetch and filter principal/vice principal messages
  const { data: allMessages = [] } = useQuery({
    queryKey: ["principalMessage", formattedCategory],
    queryFn: async () => {
      const allMessages = await getPrincipalMessage();
      return allMessages.filter((msg) => msg.category === formattedCategory);
    },
    enabled: !!formattedCategory,
  });

  // ✅ Update page title
  useEffect(() => {
    document.title = `St. Joseph’s school, Barhalganj | ${formattedCategory}`;
  }, [formattedCategory]);

  // ✅ Use dummy fallback if no data
  const hasData = Array.isArray(allMessages) && allMessages.length > 0;
  const messages = hasData
    ? allMessages
    : [
        {
          name: `${formattedCategory} Name`,
          message: "<p>Coming soon...</p>",
          attachments: null,
        },
      ];

  return (
    <>
      <Breadcrumb>{formattedCategory}</Breadcrumb>

      {/* ===== Main Section ===== */}
      <div className="innersec container my-5">
        <div className="row">
          <div className="col-lg-12">
            <h1>{formattedCategory}</h1>
          </div>

          <div className="col-lg-12">
            {messages.map((item, index) => (
              <div className="clearfix" key={index}>
                <LazyLoad
                  offset={10}
                  placeholder={
                    <img
                      src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/profilethumb.png"
                      alt="Loading..."
                      className="img-fluid"
                    />
                  }>
                  <img
                    src={
                      item.attachments
                        ? `https://webapi.entab.info/api/image/${item.attachments}`
                        : "https://webapi.entab.info/api/image/SJSKBUP/public/Images/profilethumb.png"
                    }
                    alt={item.name || "Profile"}
                    className="col-md-4 float-md-end left-img img-fluid"
                  />
                </LazyLoad>

                <div
                  className="innermsg"
                  dangerouslySetInnerHTML={{
                    __html: item.message || "<p>Coming soon...</p>",
                  }}
                />

                <div className="mesdeskimg">
                  <h3>{item.name || `${formattedCategory} Name`}</h3>
                  <h5>{formattedCategory}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MessageInner;
